<template>
  <div class="columns">
    <div class="column mt-5">
      <span class="block mt-8 text-center">
        <img
          src="@/assets/img/logo.png"
          alt="Psyservice"
          class="max-w-sm"
        >
        <h2 class="max-w-md pt-4 m-auto text-center">Você ainda não tem acesso a este recurso</h2>
        <h3 class="max-w-md pt-4 m-auto text-center">Atualize para o plano premium para ter acesso a publicação de posts e outros benefícios</h3>
        <b-button
          type="is-primary"
          class="mt-8"
          @click="setActiveDashboardSection('subscriptionSection')"
        > Atualizar</b-button>
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions(['setActiveDashboardSection'])
  }
}
</script>
